<template >
  <div>
    <div class="title">
      <el-row>
        <el-col :span='3' style="float: left;"><span class="today">当日数据展示</span></el-col>
        <el-col style="float: right;" :span='10'>
          <el-col :span='5' style="float: right;text-align: right"><div class="btn"><el-button type='primary' size='small' @click="getResult">查 询</el-button></div></el-col>
          <el-col :span='18' style="float: right;text-align: right"><el-date-picker v-model="date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" size='small'></el-date-picker></el-col>
        </el-col>
      </el-row>
      <!-- 列表数据展示 -->
      <div class="list" v-loading='loading'>
        <el-row type="flex" justify="space-between">
          <el-col :span="5">
            <div class="icon">
              <el-row>
                <el-col :span='8'><img src="../../assets/img/人12.png" alt=""></el-col>
                <el-col :span='16'><div class="col">{{ workerNumOfDay }}</div><div class="txt">活跃平均人数</div></el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="icon">
              <el-row>
                <el-col :span='8'><img src="../../assets/img/跑步.png" alt=""></el-col>
                <el-col :span='16'><div class="col">{{ averageWalkStepsOfDay }}</div><div class="txt">计步平均数</div></el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="icon">
              <el-row>
                <el-col :span='8'><img src="../../assets/img/开机.png" alt=""></el-col>
                <el-col :span='16'><div class="col">{{ averagePowerOfDay }}</div><div class="txt">开关机平均次数</div></el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="icon">
              <el-row>
                <el-col :span='8'><img src="../../assets/img/手指.png" alt=""></el-col>
                <el-col :span='16'><div class="col">{{ averageTelephoneOfDay }}</div><div class="txt">通话平均次数</div></el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      date: '',  // 选择日期
      workerNumOfDay: '',
      averageWalkStepsOfDay: '',
      averagePowerOfDay: '',
      averageTelephoneOfDay: 5,
      projectId: '',
      loading: false,
    }
  },

  created () {
    if (this.$route.query.id) {
      this.projectId = +this.$route.query.id
    } else {
      this.projectId = +this.$store.state.projectId
    }
    this.loading = true
    this.getResult()
  },

  methods: {
    // 查询数据
    getResult () {
      this.httpPost('/web/dashboard/v1/searchStatisticalData', {
        projectId: this.projectId,
        searchDate: this.date,
      }).then(res => {
        if (res.code == 0) {
          this.loading = false
          if (res.data) {
            this.averagePowerOfDay = res.data.averagePowerOfDay
            this.averageTelephoneOfDay = res.data.averageTelephoneOfDay
            this.averageWalkStepsOfDay = res.data.averageWalkStepsOfDay
            this.workerNumOfDay = res.data.workerNumOfDay
          } else {

          }
        } else if (res.code == 10001 || res.code == 10002) {
          this.loading = false
          this.$message({
            type: 'error',
            message: res.message
          })
        } else {
          this.loading = false
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .title{
    margin-top: 50px;
    overflow: hidden;
  }
  .today{
    line-height: 30px;
    cursor: pointer;
    font-size: 15px;
    color: #555;
    font-weight: bold;
  }
  .btn{
    button{
      display: inline-block;
      margin-left: 10px;
      height: 31px;
    }
  }
  .list{
    margin-top: 50px;
    img{
      width: 50px;
      vertical-align: middle;
    }
    .txt{
      font-size: 13px;
    }
    .icon{
      div{
        padding: 0px 0 7px 0;
      }
      .col{
        color: #ff9800;
        font-size: 20px;
        font-weight: 600;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/data/dashboard.vue